export default __webpack_public_path__ + "static/media/pic-6.9cf72fe3.png";